module.exports = __webpack_public_path__ + "img/dex.bdc300f1.svg";